import { MONITOR_TYPES } from '../../../../constants/monitor.types';

export const canShowMonitorForm = (canCreateMap, monitorType, serverCreated) =>
    !!canCreateMap[monitorType] || (
        monitorType === MONITOR_TYPES.SERVER && !!serverCreated
    );

export const selectAvailableMonitorType = (
    canCreateMap,
    currentType,
    serverCreated
) => {
    if (canShowMonitorForm(canCreateMap, currentType, serverCreated)) {
        return currentType;
    }
    return Object.values(MONITOR_TYPES).find(type => canCreateMap[type]) || null;
};
